/* USERS */
export const GET_PATIENTS_OPTIONS = "GET_PATIENTS_OPTIONS";
export const GET_PATIENTS_OPTIONS_SUCCESS = "GET_PATIENTS_OPTIONS_SUCCESS";
export const GET_PATIENTS_OPTIONS_FAIL = "GET_PATIENTS_OPTIONS_FAIL";
